import { render, staticRenderFns } from "./ImageManage.vue?vue&type=template&id=a18f22e0&scoped=true&"
import script from "./ImageManage.vue?vue&type=script&lang=ts&"
export * from "./ImageManage.vue?vue&type=script&lang=ts&"
import style0 from "./ImageManage.vue?vue&type=style&index=0&id=a18f22e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18f22e0",
  null
  
)

export default component.exports